export enum TOGGLE_TRACK_CHANGES_ACTION {
	TOGGLE_TRACK_CHANGES = 'TOGGLE_TRACK_CHANGES',
}
